export enum CoverTypeEnum {
  HOUSEHOLDS = "HOUSEHOLDS",
  POPULATION = "POPULATION",
  TERRITORY = "TERRITORY",
  SURFACE = "SURFACE",
}
